import type { GlobalTag } from '../db/types';
import { colorOf } from '../lib/colors';
import './FilterBar.css';

interface Props {
  tags: GlobalTag[];
  onRemove: (tagId: string) => void;
  onClear: () => void;
}

/**
 * The filters stacked on top of the current selection.
 *
 * The sidebar shows where you are; this shows what you have narrowed it to.
 * Keeping them apart is what lets "List + Global Tag" work without the sidebar
 * having to represent two highlighted things at once.
 */
export function FilterBar({ tags, onRemove, onClear }: Props) {
  if (tags.length === 0) return null;

  return (
    <div className="filters">
      <span className="filters__label">and tagged</span>
      {tags.map((tag) => {
        const hex = colorOf(tag.color);
        return (
          <span className="chip filters__chip" key={tag.id}>
            <span
              className="tagf__dot"
              style={{ background: hex ?? 'var(--border-strong)' }}
              aria-hidden="true"
            />
            <span className="chip__value">{tag.name}</span>
            <button
              type="button"
              className="chip__x"
              aria-label={`Stop filtering by ${tag.name}`}
              onClick={() => onRemove(tag.id)}
            >
              ✕
            </button>
          </span>
        );
      })}
      {tags.length > 1 && (
        <button type="button" className="filters__clear" onClick={onClear}>
          Clear
        </button>
      )}
    </div>
  );
}
